var map = {
	"./app-api.json": 35902,
	"./auth-api.json": 94159,
	"./community-api.json": 58276,
	"./education-api.json": 22007,
	"./mmproxy-api.json": 79211,
	"./upload-api.json": 79136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71700;